var map = {
	"./de.json": [
		1721,
		41
	],
	"./en-AU.json": [
		1722,
		42
	],
	"./en-GB.json": [
		1723,
		43
	],
	"./en-HK.json": [
		1724,
		44
	],
	"./en-SG.json": [
		1725,
		45
	],
	"./en-us.json": [
		1726,
		46
	],
	"./fr.json": [
		1727,
		47
	],
	"./global.json": [
		1728,
		48
	],
	"./it.json": [
		1729,
		49
	],
	"./zh-Hant.json": [
		1730,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1718;
module.exports = webpackAsyncContext;